<template>
    <div class="case-study-carousel w-full" v-touch:swipe="slide">
        <div ref="carouselContent" class="case-study-carousel__content w-full flex flex-no-wrap justify-start items-start">
            <div v-for="(image, index) in images" :key="'slide'+index" class="slide-item w-screen relative flex-no-shrink">
                <img :src="image.url" class="slide-item__image w-full">
            </div>
        </div>
        <div class="case-study-carousel__nav flex justify-center items-center">
            <div ref="dot" v-for="(image, index) in images" :key="'dot'+index" class="w-2 h-2 mr-3 bg-white rounded cursor-pointer" @click="goToIndex(index)" :class="{'current' : index === 0}"></div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';

    export default {
        name : 'case-study-carousel',

        props : {
            block : {
                type : Object,
                default : () => {}
            }
        },

        data(){
            return {
                initCanvasSlideshow : null,

                currentIndex : 0
            }
        },

        computed : {
            images(){
                return this.block.caseStudyCarousel;
            }
        },

        watch : {
            currentIndex(){
                if(this.currentIndex < 0) this.currentIndex = 0;
                if(this.currentIndex >= this.images.length - 1) this.currentIndex = this.images.length -1;

                let width = this.$refs.carouselContent.clientWidth;

                TweenMax.to(this.$refs.carouselContent, 0.8, {
                    x : - (this.currentIndex * width),
                    ease : Expo.easeOut
                });

                TweenMax.set(this.$refs.dot, {
                    className : '-=current'
                });

                TweenMax.set(this.$refs.dot[this.currentIndex], {
                    className : '+=current'
                });
            }
        },

        methods : {
            slide(pDirection) {
                if(pDirection === 'left') {
                    this.currentIndex += 1;
                } else if (pDirection === 'right') {
                    this.currentIndex += -1;
                }
            },

            goToIndex(pIndex) {
                this.currentIndex = pIndex;
            },
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .case-study-carousel {
        &__nav {
            @include bottom-left(30px, 50%);
            transform : translateX(-50%);

            @media (min-width : 768px) {
                @include bottom-left(50px, 50%);
            }

            .current {
                transition : all 0.3s ease-out;
                @apply w-1 h-1;
            }
        }
    }

    .slide-item {
        @include disable-selection;
        cursor : grab;
    }

    .slide-item:before {
        content : '';
        @include top-left(0,0);
        @apply w-full h-full;
    }
</style>

